import { useTranslation } from 'react-i18next';

const Experiences = () => {
    const { t } = useTranslation();

    return (
        <div className="mb-6">
            <h2 className="text-center h1">{t("Experiencias")}</h2>

            <div className="mb-6 row">
                <div className="col-md-5">
                    <figure className="o-cont-fullw o-cont-md-fullw__left not-xl-fullw__left o-fig-object mh-sm-240 ratio-4x3">
                        <img src="https://pro-static.h10hotels.com/gallery/T3D3/00.7_HILibraryMeetingRoom5.jpg" alt="Library" />
                        <span className="fig-logo">
                            <img src="https://pro-static.h10hotels.com/gallery/MICE65px.svg" alt="Reuniones y Eventos" />
                        </span>
                    </figure>
                </div>
                <div className="col-md-7 d-flex flex-column justify-content-center align-items-start px-md-6">
                    <h3 className="h2 h1-md-vw">{t("Reuniones y Eventos")}</h3>
                    <div className="ps-md-6">
                        <p ></p>
                        <app-read-more _nghost-ng-c137762624="">
                            <div _ngcontent-ng-c137762624="" className="js-txtoverflow">
                                <p>{t("Dispone de cuatro salones de reuniones renovados en 2018 que cuentan con luz natural y son ideales para todo tipo de eventos. Los salones Tàpies y Miró son panelables y cuando se unen al restaurante De Blanc pueden acoger a 150 personas. El hotel también ofrece la exclusiva terraza El Jardí, de 700 m², un espacio perfecto para cócteles de hasta 120 personas.")}</p>
                            </div>
                            <button _ngcontent-ng-c137762624="" type="button" className="btn btn-link btn-txtoverflow" style={{ display: "none" }}> {t("Leer más")} </button>
                        </app-read-more>
                        <a className="btn btn-primary btn-100w-sm" href="/es/hoteles-barcelona/h10-itaca/reuniones-eventos" target="_self">{t("MÁS INFORMACIÓN")}</a>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default Experiences;
